import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableDepositRoutes = Loadable(
  './DepositRoutes',
  () => import(/* webpackChunkName: "Deposit" */ './DepositRoutes'),
  () => [(require as any).resolveWeak('./DepositRoutes')]
);
